import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { defaultNS, ns, resources } from './i18n/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: import.meta.env.DEV,
    defaultNS,
    ns,
    resources,
    // POR-448: i18next HTML-escapes interpolated values by default, so a server apostrophe reached
    // the user as `&#39;` — React already escapes at render time. The sink to watch is <Trans>,
    // which HTML-parses interpolated values into elements; oxlint's no-danger covers the other one.
    interpolation: { escapeValue: false },
  });

export default i18n;
